var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradientBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 278.337,
    height: 350.076,
    viewBox: "0 0 278.337 350.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aaae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#672784"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-109.831 -293.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M41.9-71.74C84.425-71.74,154,34.474,154,77A77,77,0,0,1,0,77C0,34.474-.627-71.74,41.9-71.74Z",
    transform: "translate(172 427.873)",
    fill: "url(#radial-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBlue);
export default __webpack_public_path__ + "static/media/gradient-blue.bf9cb2e1b0e158b83a3c13b8c578ea44.svg";
export { ForwardRef as ReactComponent };